module.exports = __webpack_public_path__ + "img/head-side-cough.2d75683d.svg";